import * as HoverCard from "@radix-ui/react-hover-card";
import classNames from "classnames";
import { forwardRef, useCallback } from "react";
import { bgColorForStep } from "~/components/Playground/Node/colors";
import { BaseStep } from "~/lib/pipeline/Step";
import { useBuild } from "~/components/build/Show/lib/BuildContext";
import { twMerge } from "tailwind-merge";
export { Trigger, Portal } from "@radix-ui/react-hover-card";

interface Props extends Pick<BaseStep, "state" | "outcome" | "missingDependencies"> {
  children: React.ReactNode;
  noBorder?: boolean;
}

export const Root = ({ children }: React.ComponentProps<typeof HoverCard.Root>) => (
  <HoverCard.Root openDelay={750} closeDelay={75}>
    {children}
  </HoverCard.Root>
);

export const Content = forwardRef<
  React.ElementRef<typeof HoverCard.Content>,
  React.ComponentProps<typeof HoverCard.Content> & Props & { noBorder?: boolean }
>(
  (
    {
      state,
      outcome,
      missingDependencies,
      children,
      noBorder,
      collisionBoundary,
      collisionPadding,
      className,
      side = "top",
    },
    ref,
  ) => {
    const { build } = useBuild({ strict: false });

    const preventSelection = useCallback((event: React.MouseEvent) => event.stopPropagation(), []);

    return (
      <HoverCard.Content
        ref={ref}
        side={side}
        sideOffset={10}
        onClick={preventSelection}
        className={twMerge(
          classNames(
            "rounded-2 depth-800 z-20 w-96 p-3",
            "data-[state=open]:animate-[slideUp_100ms_cubic-bezier(0.16,1,0.3,1)_forwards]",
            "data-[state=closed]:animate-[slideDown_25ms_linear_forwards]",
            {
              "border border-t-4": !noBorder,
            },
            bgColorForStep({ state, outcome, missingDependencies }, build),
            "bg-white",
          ),
          className,
        )}
        collisionBoundary={collisionBoundary}
        collisionPadding={collisionPadding}
      >
        {children}
      </HoverCard.Content>
    );
  },
);
